module.exports = __webpack_public_path__ + "static/img/Logo_GAES_V.51ff744.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logos/Logo_GAES_V.png
// module id = 169
// module chunks = 6